(function () {
  "use strict";

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function updateCartCount(count) {
    qsa("#cart-count-header, #cart-count-mobile").forEach(function (el) {
      el.textContent = count;
    });
  }

  /* ---------- Mobile menu ---------- */
  var mobileMenu = qs("#mobile-menu");
  var mobileBackdrop = qs("#mobile-menu-backdrop");

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add("open");
    if (mobileBackdrop) mobileBackdrop.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove("open");
    if (mobileBackdrop) mobileBackdrop.classList.remove("open");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-mobile-menu-open]")) openMobileMenu();
    if (e.target.closest("[data-mobile-menu-close]")) closeMobileMenu();
    if (e.target === mobileBackdrop) closeMobileMenu();

    var groupToggle = e.target.closest("[data-mm-toggle]");
    if (groupToggle) {
      var group = groupToggle.closest(".mm-group");
      if (group) group.classList.toggle("open");
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMobileMenu();
  });

  /* ---------- Product page ---------- */
  var pdpWrapper = qs("[data-product-form-wrapper]");
  if (pdpWrapper) {
    var variantsScript = qs("[data-product-json]");
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var selectedOptions = {};
    var priceScript = qs('[data-variant-prices]');
    var displayPrices = priceScript ? JSON.parse(priceScript.textContent) : {};
    var initialId = qs('#pdp-variant-id').value;
    var adding = false;
    var mainImage = qs('#pdp-main-img');
    var defaultImageBackground = mainImage ? mainImage.style.backgroundImage : '';
    var defaultImageZoom = mainImage ? mainImage.getAttribute('data-zoom') : '';
    var colorGroup = qsa('.pdp-sizes', pdpWrapper).find(function (group) {
      return !!qs('.pdp-variant-color', group);
    });
    var colorOptionIndex = colorGroup ? Number(colorGroup.getAttribute('data-option-index')) : -1;

    // Pre-select the first available variant's options.
    var initialVariant = variants.find(function (v) { return String(v.id) === initialId; }) || variants.find(function (v) { return v.available; }) || variants[0];
    if (initialVariant) {
      (initialVariant.options || []).forEach(function (val, i) { selectedOptions[i] = val; });
    }

    function markInitialButtons() {
      qsa(".pdp-sizes").forEach(function (group) {
        var idx = group.getAttribute("data-option-index");
        var val = selectedOptions[idx];
        qsa(".pdp-size-btn", group).forEach(function (btn) {
          btn.classList.toggle("active", btn.getAttribute("data-option-value") === val);
        });
      });
    }
    markInitialButtons();

    function findMatchingVariant() {
      return variants.find(function (v) {
        return (v.options || []).every(function (val, i) { return selectedOptions[i] === val; });
      });
    }

    // Exact variant images take priority. Otherwise reuse an image from the
    // same named color, independent of gallery order, size order or stock.
    function imageForVariant(variant) {
      if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
      if (colorOptionIndex < 0) return null;
      var color = selectedOptions[colorOptionIndex];
      var donor = variants.filter(function (candidate) {
        return candidate.options[colorOptionIndex] === color &&
          candidate.featured_image && candidate.featured_image.src;
      }).sort(function (a, b) { return Number(a.id) - Number(b.id); })[0];
      return donor ? donor.featured_image.src : null;
    }

    function refreshFromVariant() {
      var variant = findMatchingVariant();
      var idInput = qs('#pdp-variant-id');
      var canBuy = !!(variant && variant.available);
      idInput.value = variant ? variant.id : '';
      idInput.disabled = !canBuy;
      var addBtn = qs('#pdp-form button[name="add"]');
      if (addBtn) {
        addBtn.disabled = !canBuy || adding;
        addBtn.textContent = variant ? (canBuy ? 'Add to Cart' : 'Sold Out') : 'Unavailable';
      }
      var payment = qs('#pdp-form .shopify-payment-button');
      if (payment) payment.hidden = !canBuy || adding;
      var status = qs('#pdp-availability');
      if (status) status.textContent = canBuy ? '' : (variant ? 'This combination is sold out.' : 'This combination is not offered.');
      var money = variant && displayPrices[String(variant.id)];
      if (money) qs('#pdp-price-usd').textContent = money.price;
      var compare = qs('#pdp-compare-price');
      if (compare) { compare.textContent = money ? money.compare : ''; compare.hidden = !(money && money.compare); }
      qsa('.pdp-sizes', pdpWrapper).forEach(function (group) {
        var index = Number(group.getAttribute('data-option-index'));
        qsa('.pdp-size-btn', group).forEach(function (button) {
          var value = button.getAttribute('data-option-value');
          var selected = selectedOptions[index] === value;
          var available = variants.some(function (candidate) {
            return candidate.available && candidate.options.every(function (option, i) {
              return option === (i === index ? value : selectedOptions[i]);
            });
          });
          button.classList.toggle('active', selected);
          button.classList.toggle('is-unavailable', !available);
          button.setAttribute('aria-pressed', String(selected));
          button.title = value + (available ? '' : ' — unavailable with current choices');
        });
      });
      var imageSource = imageForVariant(variant);
      var main = qs('#pdp-main-img');
      if (main) {
        main.style.backgroundImage = imageSource ? 'url("' + imageSource + '")' : defaultImageBackground;
        main.setAttribute('data-zoom', imageSource || defaultImageZoom || '');
        qsa('.pdp-thumb', pdpWrapper).forEach(function (thumb) { thumb.classList.remove('active'); });
      }
    }
    refreshFromVariant();

    function formatMoney(cents) {
      return "$" + (cents / 100).toFixed(2);
    }

    document.addEventListener("click", function (e) {
      var sizeBtn = e.target.closest(".pdp-size-btn");
      if (sizeBtn) {
        var group = sizeBtn.closest(".pdp-sizes");
        var idx = group.getAttribute("data-option-index");
        qsa(".pdp-size-btn", group).forEach(function (b) { b.classList.remove("active"); });
        sizeBtn.classList.add("active");
        selectedOptions[idx] = sizeBtn.getAttribute("data-option-value");
        refreshFromVariant();
      }

      var thumb = e.target.closest(".pdp-thumb");
      if (thumb) {
        qsa(".pdp-thumb").forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
             var main = qs("#pdp-main-img");
        if (main) {
          main.style.backgroundImage = "url('" + thumb.getAttribute("data-full") + "')";
          main.setAttribute("data-zoom", thumb.getAttribute("data-zoom"));
        }
      }

      if (e.target.closest("[data-qty-decrease]")) {
        var qtyInput = qs("#pdp-qty");
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      }
      if (e.target.closest("[data-qty-increase]")) {
        var qtyInput2 = qs("#pdp-qty");
        qtyInput2.value = (parseInt(qtyInput2.value, 10) || 1) + 1;
      }
    });

    var pdpForm = qs("#pdp-form");
    if (pdpForm) {
      pdpForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var chosen = findMatchingVariant();
        if (adding || !chosen || !chosen.available || !pdpForm.reportValidity()) return;
        var formData = new FormData(pdpForm);
        formData.set('id', String(chosen.id));
        adding = true;
        refreshFromVariant();
        fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            var msg = qs("#pdp-added-msg");
            if (msg) {
              msg.classList.add("show");
              setTimeout(function () { msg.classList.remove("show"); }, 2500);
            }
            return fetch("/cart.js").then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
          })
          .catch(function (err) {
            alert((err && err.description) || "Couldn't add this item to your bag. Please check the selected size, color and quantity.");
          })
          .finally(function () { adding = false; refreshFromVariant(); });
      });
    }
  }

  /* ---------- Cart page ---------- */
  var cartForm = qs("#cart-form");
  if (cartForm) {
    var cartUpdating = false;
    var savedCartQuantities = {};
    qsa('[data-cart-qty-input]', cartForm).forEach(function (input) {
      savedCartQuantities[input.getAttribute('data-line')] = input.value;
    });
    function changeLine(line, quantity) {
      if (cartUpdating) return;
      line = Number(line);
      quantity = Number(quantity);
      if (!Number.isInteger(line) || line < 1 || !Number.isInteger(quantity) || quantity < 0) return;
      cartUpdating = true;
      cartForm.setAttribute('aria-busy', 'true');
      var controls = qsa('[data-cart-qty-input], [data-cart-qty-increase], [data-cart-qty-decrease]', cartForm);
      var previousDisabled = controls.map(function (control) { return control.disabled; });
      controls.forEach(function (control) { control.disabled = true; });
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(cartRoot + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.errors) {
              throw new Error(data.description || data.message || (typeof data.errors === 'string' ? data.errors : 'Unable to update quantity. Please try again.'));
            }
            return data;
          });
        })
        .then(function () { window.location.reload(); })
        .catch(function (err) {
          qsa('[data-cart-qty-input]', cartForm).forEach(function (input) {
            input.value = savedCartQuantities[input.getAttribute('data-line')];
          });
          alert(err.message || 'Could not update your bag. Check your connection and try again.');
          cartUpdating = false;
          cartForm.setAttribute('aria-busy', 'false');
          controls.forEach(function (control, index) { control.disabled = previousDisabled[index]; });
        });
    }

    document.addEventListener("click", function (e) {
      var dec = e.target.closest("[data-cart-qty-decrease]");
      var inc = e.target.closest("[data-cart-qty-increase]");
      var remove = e.target.closest("[data-cart-remove]");
      if (dec || inc || remove) e.preventDefault();
      if (dec) {
        var input = qs('[data-cart-qty-input][data-line="' + dec.getAttribute("data-line") + '"]');
        changeLine(dec.getAttribute("data-line"), Math.max(0, parseInt(input.value, 10) - 1));
      }
      if (inc) {
        var input2 = qs('[data-cart-qty-input][data-line="' + inc.getAttribute("data-line") + '"]');
        changeLine(inc.getAttribute("data-line"), parseInt(input2.value, 10) + 1);
      }
      if (remove) {
        changeLine(remove.getAttribute("data-line"), 0);
      }
    });

    qsa("[data-cart-qty-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        changeLine(input.getAttribute("data-line"), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
  }
    /* ---------- Hero slideshow ---------- */
  qsa(".hero-slideshow").forEach(function (root) {
    var slides = qsa(".hero-slide", root);
    if (slides.length < 2) return;

    var dots = qsa(".hero-dot", root);
    var current = 0;
    var autoplayMs = parseInt(root.getAttribute("data-autoplay"), 10) || 0;
    var timer = null;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle("active", i === current); });
      dots.forEach(function (d, i) { d.classList.toggle("active", i === current); });
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }
    function startAutoplay() {
      stopAutoplay();
      if (autoplayMs) timer = setInterval(next, autoplayMs);
    }

    var prevBtn = qs("[data-hero-prev]", root);
    var nextBtn = qs("[data-hero-next]", root);
    if (prevBtn) prevBtn.addEventListener("click", function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener("click", function () { next(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { show(i); startAutoplay(); });
    });

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    startAutoplay();
  });

  /* ---------- Product image zoom lightbox ---------- */
  var lightbox = qs("#pdp-lightbox");
  var lightboxImg = qs("#pdp-lightbox-img");

  function openLightbox() {
    var main = qs("#pdp-main-img");
    if (!main || !lightbox || !lightboxImg) return;
    var zoomSrc = main.getAttribute("data-zoom");
    if (zoomSrc) lightboxImg.src = zoomSrc;
    lightbox.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove("open");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-pdp-zoom]")) openLightbox();
    if (e.target.closest("[data-pdp-lightbox-close]")) closeLightbox();
    if (e.target.id === "pdp-lightbox") closeLightbox();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeLightbox();
  });

  if (lightboxImg) {
    lightboxImg.addEventListener("mousemove", function (e) {
      var rect = lightboxImg.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      lightboxImg.style.transformOrigin = x + "% " + y + "%";
      lightboxImg.style.transform = "scale(2.4)";
    });
    lightboxImg.addEventListener("mouseleave", function () {
      lightboxImg.style.transform = "scale(1)";
    });
  }
/* ---------- Color swatch selection ---------- */
function selectProductColor(swatch) {
  var group = swatch.closest("[data-pdp-colors]");
  var wrapper = group.closest("[data-product-form-wrapper]");
  if (!wrapper) return;

  var swatches = qsa(
    ".pdp-color-swatch[data-color-value]",
    group
  );
  var colorNumber = swatches.indexOf(swatch) + 1;

  swatches.forEach(function (button) {
    var selected = button === swatch;
    button.classList.toggle("active", selected);
    button.setAttribute("aria-pressed", String(selected));
  });

  var input = qs("#pdp-selected-color", wrapper);
  if (input) {
    input.value = swatch.getAttribute("data-color-value");
  }

  var matchingThumb = qsa(".pdp-thumb", wrapper).find(
    function (thumb) {
      var text = thumb.getAttribute("data-color-map") || "";
      var match = text.match(/\[colors:([\d,\s]+)\]/i);
      if (!match) return false;

      return match[1].split(",").some(function (number) {
        return Number(number.trim()) === colorNumber;
      });
    }
  );

  if (matchingThumb) {
    matchingThumb.click();
  }
}

document.addEventListener("click", function (event) {
  var swatch = event.target.closest(
    "[data-pdp-colors] .pdp-color-swatch[data-color-value]"
  );
  if (swatch) selectProductColor(swatch);
});

qsa("[data-pdp-colors]").forEach(function (group) {
  var selected =
    qs(".pdp-color-swatch.active[data-color-value]", group) ||
    qs(".pdp-color-swatch[data-color-value]", group);

  if (selected) selectProductColor(selected);
});
})();
